import { render, staticRenderFns } from "./State.vue?vue&type=template&id=5a97c1b2&scoped=true&"
import script from "./State.vue?vue&type=script&lang=ts&"
export * from "./State.vue?vue&type=script&lang=ts&"
import style0 from "./State.vue?vue&type=style&index=0&id=5a97c1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97c1b2",
  null
  
)

export default component.exports